import React, {useMemo, useRef, useState} from 'react'
import ProjectStep from "../components/ProjectStep";
import InfoTooltip from "../../../components/InfoTooltip";
import Project from "../../../models/Project";
import User from "../../../models/User";
import {useAuth} from '../../../providers/AuthProvider';
import Select from "react-select";
import {useMount} from "react-use";
import {Empty} from "antd";
import ProjectUsersTable from "../components/ProjectUsersTable";
import {useProjectForm} from "../../../providers/ProjectFormProvider";
import {useAPI} from "../../../config/API";


export default class NameStep extends ProjectStep {

    static TranslationKey = 'name_step';

    static path = '/name';

    static slug = 'name';

    static sectionName = 'Project Profile';
    static ValidationMethodName = 'validateName';
    static StepName = 'Name and Owners'; // not using from create_project.php translations

    static hasCompleted(project) {

        return project.validateName();
    }

    /**
     * @param {Project} project
     * @param auth
     * @returns {Object}
     */
    static reviewMapping(project,auth) {
        // if (!auth) {
        //     return {};
        // }
        //TODO REMOVE TEMP FIX BELOW FOR AUTH USER
        const authUser = TB.auth().user();

        let allowedGroups = [];
        if (!authUser) {
            allowedGroups = [{name: 'default'}];
        }else {
            allowedGroups = auth.checkAllowedToCreateProjectGroups();
        }

        let mapping = {
            // 'Project Name and Ownership': {
            'Project Name': {
                ['Name']: project.name
            }
        }
        if (allowedGroups.length) {
            mapping['Project Name']['Group'] = project.client_project_group?.name || 'Public'
        }

        let displayedAssignedUsers = [];
        for (let user of project.assigned_users) {
            if (authUser.is_client && user.is_consultant) {
                continue
            }
            displayedAssignedUsers.push(user)
        }
        if (displayedAssignedUsers.length)
        {
            mapping['Project Name']['Assigned Collaborators'] = (
                <div className="flex flex-row items-center justify-center px-3">
                    <div className="w-full mx-auto">
                    <ProjectUsersTable>
                        {displayedAssignedUsers.map(user => {
                            return (
                                <tr key={user.id} className="border-bottom">
                                    <td className="align-middle" style={{width: '100%'}}>{user.fullName?.()} {user.id === auth.id && (<span className="text-danger">(you)</span>)}</td>
                                    {/* <td className="align-middle" style={{width: '35%'}}><a className="btn-link-info" href={`mailto:${user.email}`} target="_blank">{user.email}</a></td> */}
                                    <td className="align-middle">
                                        {user.is_owner && (
                                            <p className="m-0 btn py-0 user-select-none no-click" style={{ cursor: 'default' }}>OWNER</p>
                                        )}
                                    </td>
                                    <td></td>
                                </tr>
                            )
                        })}
                    </ProjectUsersTable>
                    </div>
                </div>

            )
        }

        return mapping
    }

    onSubmit = async(model) =>
    {
        if (!model.name) {
            return this.setState({errorClass: 'is-invalid'})
        }

        let project = model;

        if (model.id === 'new') {
            await this.props.toggleDisabled(true);
            project = await this.createProject(model);
            if (project?.id) {
                return this.props.navigate({
                    pathname:  `/client/project/setup/${project.id}/description`
                }, {replace: true})
            }
        }

        await this.props.onChange(project);

        await this.props.toggleDisabled(false);

        // return this.props.goToStep(DescriptionStep, true);
        // return super.onSubmit(model);
    }

    shouldHandleSubmit(project) {
        // console.log('shouldHandleSubmit', TB.isNaN(parseInt(project.id)))
        return TB.isNaN(parseInt(project.id));
    }

    async createProject(project)
    {
        await this.promisedState({isDisabled: true});

        let model = {
            name: project.name,
            type: project.type,
            posts_on_talent_job_board: project.posts_on_talent_job_board,
            assigned_users: project.assigned_users,
        }
        model.template_id = project.template ? parseInt(
            project.template.id
        ) : null;

        model.type = project.type;

        if (TB.isDefined(project.client_project_group_id)) {
            model.client_project_group_id = project.client_project_group_id;
            if (project.client_project_group_id !== this.context?.auth?.last_client_project_group_id) {
                await TB.auth().update(User.make({...(this.context?.auth || {}), last_client_project_group_id: project.client_project_group_id}))
            }
        }

        // Add default industry
        if(model.template_id && TB.auth().user()?.clientIndustry?.()) {
            model.industries = [TB.auth().user().clientIndustry()];
        }
        console.log('createProject', model.industries)

        let newProject = await Project.create(model);

        if (!newProject) {
            let request = Project.CreateRequest;
            request.didHandleError = await request.handleError();
            if (request.didHandleError && request.shouldRerun) {
                return this.createProject(model);
            }

            await this.promisedState({isDisabled: false});
            // handle unknown error
            return;
        }
        await TB.queryClient.setQueryData(['fetchProject', parseInt(newProject?.id)],
            previousData => previousData ? newProject : undefined
        )

        await this.promisedState({isDisabled: false});

        return newProject;
    }

    /**
     * Handles form change
     *
     * @returns void
     * @param params
     */
    async onChange(params) {
        if (this.props.isDisabled) return;


        if(TB.isNaN(parseInt(params.client_project_group_id))) {
            params.client_project_group = null;
        }

        if (!TB.isNaN(parseInt(params.client_project_group_id)) && params.client_project_group_id !== this.props.project.client_project_group_id) {

            const newGroupId = parseInt(params.client_project_group_id);
            const oldGroupId = this.props.project.client_project_group_id;

            let recipients = TB.queryClient.getQueryData(['fetchRecipientUsers', {}], {
                predicate: ({queryKey}) => {
                    let params = queryKey[1] || {};
                    return !params?.group
                }, isFetching: false
            });

            if (recipients?.length) {
                let assignedUsersWithGroups = TB.map(this.props.project.assigned_users, user => {

                    let matchedRecipient = TB.find(recipients, ['id', user.id]);
                    if (matchedRecipient) {
                        return User.make({...user, ...matchedRecipient})
                    }

                    return user
                })

                let assignedUsersWithoutNewlySelectedGroupId = TB.filter(assignedUsersWithGroups, user => !user.canAddCollaboratorToGroupProject(newGroupId))

                if (assignedUsersWithoutNewlySelectedGroupId?.length) {
                    const confirm = await TB.alert(
                        'alert',
                        'Notice',
                        'Changing the project group will remove any users that do not have permissions for this group.',
                        [{ title: 'Change' }, { title: 'Cancel' }],
                    );

                    if (!confirm) {
                        //here we reset the form input and no need to notify the change to project since it was the same
                        await this.formRef.current.updateInputsWithValue({
                            client_project_group_id: oldGroupId
                        })
                        return;
                    }

                    if (confirm) {
                        let newProject = {...this.props.project, ...params};

                        newProject.assigned_users = TB.xorBy(newProject.assigned_users, assignedUsersWithoutNewlySelectedGroupId, 'id')

                        // if no owner after filter, assign to next user (ordered by auth first)
                        // if no next user, add authed user to assigned_users and make owner
                        const findOwner = TB.find(newProject.assigned_users, ['is_owner', true]);
                        if (!findOwner && newProject.assigned_users?.length) {
                            newProject.assigned_users[0].is_owner = true;
                        } else if (!findOwner) {
                            newProject.assigned_users.push({ ...this.context.auth, is_owner: true });
                        }

                        return this.props.onChange(newProject);
                    }
                }
            }

        }
        return this.props.onChange(params);
    }


    /**
     * The fields mapping for the form
     */
    formFields = () => {
        if (!this.context?.auth) {
            return [];
        }

        const allGroups = this.context.auth.client_project_groups || [];
        const allowedGroups = TB.keyBy(this.context?.auth?.checkAllowedToCreateProjectGroups(), 'id');
        // const allowedGroups = [];

        let fields = [
            {
                fields: {
                    name: {
                        label: 'What do you want to name your project?',
                        required: true,
                        placeholder: 'Project Name',
                        validationErrors: this.defaultRequiredValidation("project name")
                    },
                    name_hint: (
                        <label className="col-form-label-hint" data-required={true}>
                            {this.translate("input_help")}
                        </label>
                    ),
                }
            }
        ]
        // only show select field if current user has groups
        if (!!allGroups.length) {
            let groupFields = {
                client_project_group_id: {
                    label: (
                        <React.Fragment>
                            Which group within your company do you want to assign this project to?
                            <InfoTooltip placement="bottom" iconSize={14}>
                                Groups are used within the Wripple platform to manage workflow, project visibility and permissions across company users. You are currently a member of the groups shown below. If you have any questions, contact your company's Wripple administrator or your Wripple client lead.
                            </InfoTooltip>
                        </React.Fragment>
                    ),
                    type: 'radio',
                    required: false,
                    placeholder:'Public (company-wide)',
                    options: [{
                        label: 'Public (company-wide)',
                        value: undefined
                    }].concat(TB.reduce(allGroups, (options, group) => {
                        options.push({
                            label:group.name,
                            value:group.id,
                            // Temp fix
                            // disabled: !group.can_create_project
                        })
                        return options
                    }, [])),
                    className: 'client-project-groups mt-4',
                }
            }


            if (TB.filter(allGroups, ['can_create_project', false]).length > 0) {
                groupFields.disabledFields = (
                    <div>
                        {TB.filter(allGroups, ['can_create_project', false]).map(group => (
                            <InfoTooltip
                                key={group.id + 'disabled-info'}
                                type="danger"
                                placement="right"
                                target={`radio-input-${group.id}`}>
                                You don't have the appropriate permissions to create a project in this group
                            </InfoTooltip>
                        ))}
                    </div>
                )
            }

            fields.push({
                fields: groupFields
            })
        }

        const assignedFields = {
            assigned_spacer: (
                <div className="w-full my-5"/>
            ),
            assigned_users: {
                component: (
                    <AssignedUserComponent
                        onChange={this.props.onChange}
                        group={this.props.project.client_project_group_id} />
                )
            }
        }

        fields.push({ fields: assignedFields })

        return fields
    };
}


const AssignedUserComponent = props => {
    const {auth} = useAuth();
    const selectInputRef = useRef();

    const {project: currentProject,formModel: project, isDisabled, onFormChange} = useProjectForm();
    let client_project_group_id = props.group;

    // Adding a state value for the select box so we can control it clearing on selection
    const [selectValue, setSelectValue] = useState('');
    const filterUserParam = useMemo(() => auth.canManageClients() ? `?type=${laravel.user_types.client}&include_consultants=true` : `?type=${laravel.user_types.client}`, [auth])
    const {
        data: recipients,
        isLoading: isLoadingRecipients,
        error,
        refetch,
    } = useAPI(['fetchRecipientUsers', {queryParams: filterUserParam}]);

    useMount(() => {
        if (!project.assigned_users?.length) {
            props.onChange({ assigned_users: [User.make({ ...TB.pick(auth, ['id', 'first_name', 'last_name']), is_owner: true })]})
        }else {
            onFormChange({assigned_users: currentProject.assigned_users})
        }
    })

    const owner = useMemo(() => {
        return TB.find(project.assigned_users, ['is_owner', true]);
    }, [project.assigned_users?.length, isDisabled]);

    const assignedUsers = useMemo(() => {
        return TB.filter(project.assigned_users, user => !user?.is_owner);
    }, [project.assigned_users?.length, owner, isDisabled]);

    const addAssignedUsers = user => {
        // if option is empty because it was cleared, do nothing
        if(!user) return;
        const newProject = {...project};

        // Add User.make to fix calling fullName() function
        newProject.assigned_users = [...project.assigned_users, User.make({ ...user, is_owner: false })];
        props.onChange(newProject);
    }

    const removeAssignedUser = user => {
        const newProject = {...project};
        newProject.assigned_users = newProject.assigned_users.filter(item => {
            return item.id !== user.id;
        });
        props.onChange(newProject);
    }

    const makeOwner = user => {
       // Again adding User.make
        let currentUsers = [...project.assigned_users];

        // remove current owner and push to top of assigned
        if(owner) {
            currentUsers = TB.filter(currentUsers, user => user.id !== owner.id);

            currentUsers.unshift(User.make({...owner, is_owner: false}));
        }
        props.onChange( {
            ...project,
            assigned_users: TB.map(project.assigned_users,member => {
                return User.make({ ...member, is_owner: user.id === member.id })
            })
        });
    }

    const sortedUsers = useMemo(() => {
        if(!recipients) return []

        // filter and then sort
        let assignedUserIds = TB.map(project.assigned_users, 'id');

        const filteredUsers = TB.filter(recipients, user => {
            return user.is_active && !assignedUserIds.includes(user.id)
        });

        if(!client_project_group_id) return filteredUsers;

        return TB.orderBy(filteredUsers, [
            'is_owner',
            'is_consultant',
            user => user.canAddCollaboratorToGroupProject(client_project_group_id)
        ], ['asc', 'asc','asc'])
    }, [
        assignedUsers,
        client_project_group_id,
        recipients?.length,
        isLoadingRecipients
    ])

    let displayedAssignedUsers = []
    for (let user of assignedUsers) {
        if (user.is_consultant && auth.is_client) {
            continue;
        }

        displayedAssignedUsers.push(user)
    }

    // if (isLoadingRecipients) return null;

    // custom label for react select dropdown
    const formatOptionLabel = (option) => {

    const isAllowed = !client_project_group_id || option.canAddCollaboratorToGroupProject(client_project_group_id);
        return (
            <div style={{ fontSize: 12, display: "flex", justifyContent: 'space-between',  color: !isAllowed ? '#a3a3a3' : 'unset' }}>
                <div>{option.fullName()} {option.id === auth.id && (<span className="text-danger">(you)</span>)}</div>
                {!isAllowed ? (
                    <div>
                        User not apart of group
                    </div>
                ) : (
                    <div>
                        {option.email}
                    </div>
                )}
            </div>
        )
    }

    return (
        <div className="flex flex-col items-stretch">
            <label className="col-form-label mb-2">Who from your company is on point for this search?</label>

            {owner && (
                <React.Fragment>
                    <h4 className="text-lg">Project Owner</h4>
                    <ProjectUsersTable className="mt-3 w-full relative" animationProps={{enterAnimation:"fade", leaveAnimation:"none" }}>
                        <tr className="border-bottom" key={owner.id}>
                            <td className="align-middle" style={{width: '100%'}}>{owner.fullName?.()} {owner.id === auth.id && (<span className="text-danger">(you)</span>)}</td>
                            {/* <td className="align-middle" style={{width: '35%'}}><a className="btn-link-info" href={`mailto:${owner.email}`} target="_blank">{owner.email}</a></td> */}
                            <td className="align-middle">
                                <p className="m-0 btn py-0 user-select-none no-click" style={{ cursor: 'default' }}>OWNER</p>
                            </td>
                            <td>
                                <button
                                    type="button"
                                    onClick={() => true}
                                    className="btn btn-link"
                                    // className={TB.mapClass("btn btn-link", {"no-click": user.is_owner})}
                                    // disabled={user.is_owner}
                                    id={`user-${owner.id}`}
                                >
                                    Remove
                                </button>

                                <InfoTooltip
                                    type="dark"
                                    placement="top"
                                    target={`user-${owner.id}`}
                                >
                                    You must set a collaborator as a new Owner before removing.
                                </InfoTooltip>
                            </td>
                        </tr>
                    </ProjectUsersTable>
                </React.Fragment>
            )}
            <h4 className="text-lg">Assign Project Collaborators</h4>
            <p className="text-sm text-light-gray6 mt-1 mb-3">Project collaborators are notified of project and talent updates</p>

            <div className="max-w-[400px] mb-4">

                {/* Setting select value so it never fills the input*/}
                <Select
                    ref={selectInputRef}
                    placeholder="Search User"
                    options={sortedUsers}
                    value={selectValue}
                    onChange={addAssignedUsers}
                    formatOptionLabel={formatOptionLabel}
                    getOptionValue={(option) => option.fullName() + ' ' + option.email}
                    isClearable={true}
                    isOptionDisabled={client_project_group_id ? (option) => !option.canAddCollaboratorToGroupProject(client_project_group_id) : undefined}
                />
            </div>

            {displayedAssignedUsers?.length > 0 ? (
                <ProjectUsersTable className="mt-3">

                {displayedAssignedUsers.map(user => {
                        return (
                            <tr key={user.id} className="border-bottom">
                                <td className="align-middle" style={{width: '100%'}}>{user.fullName?.()} {user.id === auth.id && (<span className="text-danger">(you)</span>)}</td>
                                {/* <td className="align-middle" style={{width: '35%'}}><a className="btn-link-info" href={`mailto:${user.email}`} target="_blank">{user.email}</a></td> */}
                                <td className="align-middle">
                                    {user.is_owner ? (
                                        <p className="m-0 btn py-0 user-select-none no-click" style={{ cursor: 'default' }}>OWNER</p>
                                    ) : (
                                        <button
                                            type="button"
                                            className="btn btn-link btn-link-primary py-0 mx-auto whitespace-nowrap	"
                                            onClick={() => makeOwner(user)}
                                        >
                                            Make Owner
                                        </button>
                                    )}
                                </td>
                                <td>
                                    <button
                                        type="button"
                                        onClick={() => !user.is_owner && removeAssignedUser(user)}
                                        className={TB.mapClass("btn btn-link")}
                                        // className={TB.mapClass("btn btn-link", {"no-click": user.is_owner})}
                                        // disabled={user.is_owner}
                                        id={`user-${user.id}`}
                                    >
                                        Remove
                                    </button>

                                    {user.is_owner && (
                                        <InfoTooltip
                                            type="dark"
                                            placement="top"
                                            target={`user-${user.id}`}
                                        >
                                            You must set a collaborator as a new Owner before removing.
                                        </InfoTooltip>
                                    )}
                                </td>
                            </tr>
                        )
                    })}
                </ProjectUsersTable>
            ) : (
                <Empty description="Add users to this project who will be notified for updates" image={Empty.PRESENTED_IMAGE_SIMPLE} />
            )}
        </div>
    )
}